import { Validator } from 'vee-validate'

Validator.extend('falsy', {
  getMessage(field) {
    return `${field} should be falsy`
  },
  validate(value) {
    return value === false
  }
})
